export const REF_LIST_CODE = {
  FLAG_TYPE: {
    WARRANTS: 50030001,
    CIVIL_PAPER: 50030002,
    DANGER: 50030003,
    INJAIL: 50030004,
    GANG_MEMBER: 50030005,
    MEDICAL: 50030006,
    NOTES: 50030007,
  },
  INTERFACE_TYPES: {
    YESNO: 50000001,
    TEXTBOX: 50000002,
    BIGTEXT: 50000003,
    SELECT: 50000004,
    DATE: 50000005,
    SIGNATURE: 50000006,
  },
  BQ_STEPS: {
    INTAKE: 155190001,
    MEDICAL: 155190003,
    CLASSIFICATION: 155190005,
    CHARGES: 155190012,
    ASSOCIATES: 155190014,
    FLAGS: 155190015,
    VICTIMS: 155190016,
    BOOKING_COMPLETE: 155190002,
    MUGSHOT: 155190007,
    HOUSING: 155190011,
    REMOVE_FROM_BQ: 155190013,
    FINGER_PRINTS: 549600030,
  },
};
